

//   // Function to generate a UUID (placeholder implementation)
// export const generateUUID =()=> {
//     return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
//       var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
//       return v.toString(16);
//     });
//   }

// utils/dataConverters.js

export const convertToTableData = (data) => {
  return data?.results?.map((item) => {
    const semesterData = item.json?.table || item.outcome || [];
    const semester = item.semester;

    return {
      id: item.id,
      semester: semester,
      semester_name: `Semester ${semester}`,
      apa_point: item?.apa_point,
      status: item.status,
      comment: item.comment || '',

      data: semesterData.map((course, index) => ({
        key: course.id || index,
        role: course.role,
        count: course.count,
        modal: course.modal || {},   // {} not [] — matches API payload
        apa_cycle: course.apa_cycle || false,
      })),
    };
  }) || [];
};

// export const convertToTableData = (data) => {
//   console.log('Data to be converted:', data); // Add this line to inspect incoming data
//   return data?.results?.map((item) => {
//     const semesterData = item.json?.table || item.outcome || [];
//     const semester = item.semester || (semesterData.length > 0 && semesterData[0].semester) || 'Unknown';

//     return {
//       id: item.id,
//       semester: semester,
//       semester_name: `Semester ${semester}`,
//       apa_point: item?.apa_point,
//       status: item.status,
//       comment: item.comment,

//       data: semesterData.map((course, index) => ({
//         key: course.id || index,
//         role: course.role,
//         count: course.count,
//         modal: course.modal || [],
//         apa_cycle: course.apa_cycle || false,

//       })),
//     };
//   }) || [];
// };

export const convertToRequestData = (planning, selectedYear, formId, semester) => {
  const semesterPlan = planning.find((plan) => plan.semester === semester);
  if (!semesterPlan) return null;

  const tableData = semesterPlan?.courses?.map((course, index) => ({
    key: course.id || index,
    role: course.role,
    count: course.count,
    modal: course.modal || {},    // {} not [] — keep consistent
    apa_cycle: course.apa_cycle || false,
  })) || [];

  return {
    apa_form: formId,
    year: selectedYear,
    semester: semester,
    apa_point: semesterPlan.apa_point || 0,
    json: {
      table: tableData,
    },
  };
};

// export const convertToRequestData = (planning, selectedYear, formId, semester) => {
//   const semesterPlan = planning.find((plan) => plan.semester === semester);
//   if (!semesterPlan) {
//     return null;
//   }


//   const tableData = semesterPlan?.courses?.map((course, index) => ({
//     key: course.id || index,
//     role: course.role,
//     count: course.count,
//     modal: course.modal,
//     apa_cycle: course.apa_cycle,
 
//   }))

 


//   return {
//     apa_form: formId,
//     year: selectedYear,
//     semester: semester,
//     apa_point: semesterPlan.apa_point || 0,
//     json: {
//       table: tableData,
//     },
//   };
// };


export const convertPlanningToRequestData = (planningData, year, apa_form) => {
  // Group all roles into their respective semesters first
  const semesterMap = { 1: [], 2: [], 3: [] };

  planningData.forEach((plan) => {
    for (let i = 1; i <= 3; i++) {
      const semesterKey = `semester_${i}`;
      if (plan[semesterKey]) {
        semesterMap[i].push({
          role: plan.role,
          count: plan[semesterKey].count,
          modal: plan[semesterKey].modal || {},
          apa_cycle: plan.apa_cycle || false,
        });
      }
    }
  });

  // One POST per semester — always 3 requests
  return [1, 2, 3].map((semester) => ({
    apa_form: apa_form,
    year: year,
    semester: semester,
    apa_point: 0,
    json: {
      table: semesterMap[semester],
    },
  }));
};
// export const convertPlanningToRequestData = (planningData, year, apa_form) => {
  
//   const convertedData = [];

//   planningData.forEach((plan) => {
//     for (let i = 1; i <= 3; i++) {
//       const semesterKey = `semester_${i}`;
//       if (plan[semesterKey]) {
//         const tableData = {
//           role: plan.role,
//           count: plan[semesterKey].count,
//           modal: {}, // Assuming modal data needs to be filled
//           apa_cycle: plan.apa_cycle,
//         };

//         convertedData.push({
//           apa_form: apa_form,
//           year: year,
//           semester: i,
//           apa_point: plan.apa_point || 0,
//           json: {
//             table: [tableData], // Wrapping in array as expected by the request format
//           },
//         });
//       }
//     }
//   });

//   return convertedData;
// };